// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1_SZV","cls2":"Unibrow-cls2_vO7 Unibrow-cls1_SZV"};